// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-breakdown{background-color:#12031d;height:100%;width:100%}.modal-breakdown-container{background-color:rgba(0,0,0,.3);box-shadow:inset 3px 1px 11px 0 rgba(0,0,0,.5);height:100%;width:100%}.modal-breakdown .text-input-label{color:hsla(0,0%,100%,.7);font-size:12px;font-weight:700}.modal-breakdown .text-input{border-bottom:2px solid hsla(0,0%,100%,.3);color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
